export default __webpack_public_path__ + "static/sparc_logo-3aa1d11354430b3440964b0475d31eab.png";